import {
    isValidElement,
    type ReactNode,
    Children,
    Fragment
} from "react";
import type {
    CollapsiblePlacementConstantType,
    CollapsiblePlacement,
    CollapsiblePartKind
} from "./type";

const getCollapsiblePartKind = (node: ReactNode): CollapsiblePartKind | undefined => {
    if(!isValidElement(node)) {
        return undefined;
    }

    const elementType: unknown = node.type;

    if(typeof elementType !== "function" || !("collapsiblePart" in elementType)) {
        return undefined;
    }

    const partKind = elementType.collapsiblePart;

    return partKind === "content" || partKind === "trigger" ? partKind : undefined;
};

const flattenCollapsibleChildren = (children: ReactNode): Array<ReactNode> => {
    const nodes: Array<ReactNode> = [];

    Children.toArray(children).forEach((child) => {
        if(isValidElement<{
            children?: ReactNode;
        }>(child) && child.type === Fragment) {
            nodes.push(...flattenCollapsibleChildren(child.props.children));

            return;
        }

        nodes.push(child);
    });

    return nodes;
};

export const getCollapsiblePlacement = ({
    children
}: CollapsiblePlacementConstantType): CollapsiblePlacement => {
    const partKinds = flattenCollapsibleChildren(children).map(getCollapsiblePartKind);

    const contentIndex = partKinds.indexOf("content");

    const triggerIndex = partKinds.indexOf("trigger");

    if(contentIndex !== -1 && triggerIndex !== -1 && contentIndex < triggerIndex) {
        return "before";
    }

    return "after";
};
